import type { FunctionComponent } from 'react';

import { BreakPoints } from '@kanda-libs/ks-design-library';

import OpenBankingSatNoteModalButton from './components/Button';
import OpenBankingSatNoteForm from './components/Form';
import OpenBankingSatNoteProvider from './context';

const PaidByBankSatNote: FunctionComponent = () => (
  <OpenBankingSatNoteProvider>
    <BreakPoints
      mobile={<OpenBankingSatNoteModalButton />}
      desktop={<OpenBankingSatNoteForm />}
    />
  </OpenBankingSatNoteProvider>
);

export default PaidByBankSatNote;
